import { Middleware } from "redux"

export const loggerMiddleware: Middleware = store => next => action => {
    console.info("dispatching", action);
    let result = next(action);
    console.info("state after", store.getState());
    return result;
}
